<div [hidden]="!isInitialized">
  @for (component of uiComponents; track component) {
    <ng-template #children></ng-template>
  }
</div>